import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Formik, Form } from 'formik';
import Grid from '@material-ui/core/Grid';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Container from '@material-ui/core/Container';
import Button from '../../../components/Button';

import BusinessInfo from './steps/BusinessInfo';
import Activation from './steps/Activation';
import Charge from './steps/Charge';
import Resume from './steps/Resume';

import { setBusinessInfo, setActivation, setCharge, clearBusinessInfoRegistration } from '../store/actions';

import { createNewEstablishment } from '../store/thunk';

import { businessInfoValidations } from './steps/BusinessInfo/validations';
import { activationValidations } from './steps/Activation/validations';
import { chargeValidations } from './steps/Charge/validations';

import { useStyles } from './styles';

export default function BusinessInfoRegistration() {
  const dispatch = useDispatch();

  const history = useHistory();

  const classes = useStyles();

  const resaleId = process.env.REACT_APP_RESALE_ID;
  const isResale = !!process.env.REACT_APP_RESALE_ID;

  const { userId } = useSelector(state => state.profile);
  const { businessInfo, charge, activation, isLoading } = useSelector(state => state.businessInfoRegistration);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    dispatch(clearBusinessInfoRegistration());
    setCurrentIndex(0);
    setIsReady(true);
  }, []);

  const configurations = [
    {
      index: 0,
      id: 'businessInfo',
      title: 'Dados da unidade',
      component: BusinessInfo,
      validations: businessInfoValidations,
      initialValues: businessInfo
    },
    {
      index: 1,
      id: 'activation',
      title: 'Ativação',
      component: Activation,
      validations: activationValidations,
      initialValues: activation
    },
    ...!isResale ? (
      [{
        index: 2,
        id: 'charge',
        title: 'Cobrança',
        component: Charge,
        validations: chargeValidations,
        initialValues: charge
      }]
    ) : (
      []
    ),
    {
      index: !isResale ? 3 : 2,
      id: 'resume',
      title: 'Resumo',
      component: Resume,
      validations: null,
      initialValues: {}
    }
  ];

  const currentConfiguration = configurations.find(config => config.index == currentIndex) || {};

  const handleSubmit = values => {
    if(currentConfiguration.id == 'businessInfo') {
      dispatch(setBusinessInfo(values));
      return handleNextStep();
    }

    if(currentConfiguration.id == 'activation') {
      dispatch(setActivation({
        deactivatedEstablishmentTerms: values.deactivatedEstablishmentTerms,
        businessDayActivationTerms: values.businessDayActivationTerms
      }));
      return handleNextStep();
    }

    if(currentConfiguration.id == 'charge') {
      dispatch(setCharge(values));
      return handleNextStep();
    }

    if(currentConfiguration.id == 'resume') {
      let params = {}

      if(charge?.chargeType == 'existing_charge') {
        params = {
          ...businessInfo,
          userId,
          newClientSl: charge?.newClientSl,
          superlogicaId: charge?.superlogicaId
        }
      }

      if(charge?.chargeType == 'same_charge') {
        params = {
          ...businessInfo,
          userId,
          newClientSl: charge?.newClientSl,
          superlogicaId: charge?.superlogicaId
        }
      }

      if(charge?.chargeType == 'another_charge') {
        params = {
          ...businessInfo,
          userId,
          newClientSl: charge?.newClientSl,
          superlogicaId: '',
          slEstablishmentName: charge?.establishmentName,
          slDocumentId: charge?.documentId,
          slPhone: charge?.phone,
          slEmail: charge?.email,
          slPostalCode: charge?.postalCode,
          slStreet: charge?.street,
          slNumber: charge?.number,
          slComplement: charge?.complement,
          slDistrict: charge?.district,
          slCity: charge?.city,
          slState: charge?.state
        }
      }

      if(isResale) {
        params = {
          ...businessInfo,
          userId,
          resaleId
        }
      }

      dispatch(createNewEstablishment(params)).then(() => {
        return history.push('/visao-geral');
      });
    }
  }

  const handlePreviousStep = () => {
    if(currentIndex == 0) {
      return history.push('/estabelecimento');
    }

    setCurrentIndex(currentIndex - 1);
  }

  const handleNextStep = () => {
    if(currentIndex == configurations[configurations.length - 1].index) {
      return;
    }

    setCurrentIndex(currentIndex + 1);
  }

  if(!isReady) {
    return null;
  }

  return(
    <Grid>
      <Stepper
        alternativeLabel
        activeStep={currentIndex}
        style={{ background: 'transparent', padding: 0, paddingBottom: 24 }}
      >
        {configurations.map((nav, index) => (
          <Step key={nav.id}>
            <StepButton
              completed={currentIndex > index}
              onClick={() => setCurrentIndex(index)}
            >
              {nav.title}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <Grid>
        <Formik
          key={currentConfiguration.id}
          enableReinitialize
          initialValues={currentConfiguration.initialValues || {}}
          validationSchema={currentConfiguration.validations}
          validateOnChange={false}
          onSubmit={handleSubmit}
        >
          {({ ...formikProps }) => {
            return(
              <Form>
                {(currentIndex == currentConfiguration.index) && (
                  <currentConfiguration.component formikProps={formikProps} />
                )}
                <Grid className={classes.footer}>
                  <Container>
                    <Grid container justify="space-between">
                      <Button
                        loading={isLoading}
                        type="button"
                        color="primary"
                        onClick={() => {
                        if(currentConfiguration.id == 'charge') {
                          dispatch(setCharge(formikProps.values));
                        }

                        handlePreviousStep();
                      }}
                      >
                        Voltar
                      </Button>
                      <Button
                        loading={isLoading}
                        color="success"
                        type="submit"
                      >
                        Avançar
                      </Button>
                    </Grid>
                  </Container>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Grid>
    </Grid>
  );
}